import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromShipments from './+state/shipments.reducer';
import { ShipmentsEffects } from './+state/shipments.effects';
import { ShipmentsFacade } from './+state/shipments.facade';
import { SharedStoresShipmentsConfig } from './shared-stores-shipments.config';
import { ShipmentExistsGuard } from './guards/shipment-exists.guard';
import { ShipmentsCustomViewsEffects } from './+state/shipments-custom-views.effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(
            fromShipments.SHIPMENTS_FEATURE_KEY,
            fromShipments.reducer
        ),
        EffectsModule.forFeature([ShipmentsEffects, ShipmentsCustomViewsEffects]),
    ],
    providers: [ShipmentsFacade, ShipmentExistsGuard],
})
export class SharedStoresShipmentsModule {
    static forFeature(
        config: SharedStoresShipmentsConfig
    ): ModuleWithProviders<SharedStoresShipmentsModule> {
        return {
            ngModule: SharedStoresShipmentsModule,
            providers: [config.service],
        };
    }
}
